import type { ReportSeverity } from '@ipfabric/utils';
import classNames from 'classnames';
import { SeverityCounts } from 'components/SeverityCounts/SeverityCounts';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';

interface Props {
  severityInfo: Record<ReportSeverity, number>;
  wrapperClassName?: string;
}

export const issueSeverities: ReportSeverity[] = [20, 30];

const hasIssues = (severityInfo: Record<ReportSeverity, number>) =>
  issueSeverities.some((severity) => severityInfo[severity] > 0);

const BarePacketDetailSeverityInfo: FC<Props> = (props) => {
  const {
    deviceView: {
      pathLookup: { severityInfo: severityInfoMsg },
    },
  } = useLocale();

  return (
    <div className={classNames('relative', props.wrapperClassName)}>
      <div className='text-lgu-lg mb-lgu-3 font-bold'>
        {hasIssues(props.severityInfo)
          ? severityInfoMsg.issuesDetected
          : severityInfoMsg.noIssuesDetected}
      </div>
      <SeverityCounts counts={props.severityInfo} />
    </div>
  );
};

export const PacketDetailSeverityInfo = memo(BarePacketDetailSeverityInfo);
